import axios from 'axios'
import * as Sentry from '@sentry/browser'
// import { isNetworkError } from 'helpers/functions'

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('aml_engine_access_token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}, (err) => {
  return Promise.reject(err)
})

axios.interceptors.response.use((response) => {
  return response
}, (err) => {
  Sentry.captureException(err)

  // const status = _.get(err, 'response.status') || err.status
  // const statusMsg = status ? `${status}: ` : ''

  // if (isNetworkError(err))
  //   toast.error(`${statusMsg} Problema na solicitação: ${err.message}`)

  return Promise.reject(err)
})

export { axios as default }
